import { customerCustomFieldDeclarationSchema } from "@redotech/redo-customer-segments-common/customer-custom-fields/customer-custom-fields-definition";
import * as z from "zod";

export const getCustomFields = {
  name: "getCustomFields" as const,
  description:
    "The store's customer custom field declarations. A custom-field condition needs a declarationId from here.",
  mutates: false,
  input: z.object({}),
  output: z.object({
    declarations: z.array(customerCustomFieldDeclarationSchema),
  }),
};
